import React from "react";
import { SelectMenu } from "@raketa-cms/raketa-cms";
import MarkdownInput from "../../../cms/Forms/MarkdownInput";
import InputSection from "../common/InputSection";
import SelectList from "../../Fields/SelectList/SelectList";

const ComparisonLinksInput = ({ comparisonData, value, onChange }) => {
  const products = Object.keys(comparisonData);
  const data = comparisonData[value.product] || {};

  return (
    <InputSection title="Comparison links">
      <SelectMenu
        label="Product"
        options={products.map((pr) => [pr, pr])}
        value={value.product || ""}
        onChange={(product) => {
          onChange({
            product,
            available_products: "",
            integrations: {
              os: [],
              cads: [],
            },
            sections: [],
          });
        }}
      />

      <MarkdownInput
        label="Available Products"
        value={value.available_products || ""}
        onChange={(available_products) =>
          onChange({ ...value, available_products })
        }
      />

      {data?.integrations?.os?.length > 0 && (
        <SelectList
          options={
            data.integrations.os.map((item) => {
              return {
                id: item.id,
                name: item.name,
              };
            }) || []
          }
          label="Operating systems"
          onChange={(os) =>
            onChange({
              ...value,
              os: os.map((item) => Number.parseInt(item, 10)),
            })
          }
          selected={value.os || []}
        />
      )}

      {data?.integrations?.cads?.length > 0 && (
        <SelectList
          options={
            data.integrations.cads.map((item) => {
              return {
                id: item.id,
                name: item.name,
              };
            }) || []
          }
          label="CAD systems"
          onChange={(cads) =>
            onChange({
              ...value,
              cads: cads.map((item) => Number.parseInt(item, 10)),
            })
          }
          selected={value.cads || []}
        />
      )}

      {data?.sections?.length > 0 &&
        data.sections.map((section) => {
          if (!section.title || section.rows?.length <= 0) {
            return null;
          }

          return (
            <SelectList
              options={
                section.rows.map((item) => ({
                  id: `${section.id}-${item.id}`,
                  name: item.label,
                })) || []
              }
              label={section.title}
              onChange={(checked) =>
                onChange({
                  ...value,
                  sections: {
                    ...value.sections,
                    [section.id]: checked,
                  },
                })
              }
              selected={(value.sections || {})[section.id] || []}
            />
          );
        })}
    </InputSection>
  );
};

export default ComparisonLinksInput;
